import LayoutErrorPage from '@flatsy/core/Layout/ErrorPage'
import FlatsyTheme from '@flatsy/core/MuiTheme/flatsyTheme'
import i18n from '@flatsy/utils/translations'
import React from 'react'

const ClosedPage: React.FC = (): React.ReactElement => {
  return (
    <LayoutErrorPage
      title={i18n.t('unfortunately_this_property_isnt_available_anymore')}
      text={i18n.t('good_luck_in_your_search')}
      image={FlatsyTheme.image.indispo}
    />
  )
}

export default ClosedPage
